<!-- Header para desktop -->
<header class="header-profile desktop-header"
        [class.password-change-height]="isPasswordChangeSection"
        [class.user-collapsed]="isUserDataCollapsed">
  <div class="header-container">
    <!-- Sección izquierda: Botón Home -->
    <div class="header-left">
      <button
        mat-icon-button
        class="action-btn home-btn"
        (click)="navigateTo('/home')"
        aria-label="Inicio">
        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.59191 0.496049C9.41459 -0.164047 10.5854 -0.164048 11.4081 0.496048L19.1581 6.71438C19.6903 7.14142 20 7.78693 20 8.46931V19.7497C20 20.9923 18.9926 21.9997 17.75 21.9997H14.75C13.5074 21.9997 12.5 20.9923 12.5 19.7497V13.7497C12.5 13.3355 12.1642 12.9997 11.75 12.9997H8.25C7.83579 12.9997 7.5 13.3355 7.5 13.7497V19.7497C7.5 20.9923 6.49264 21.9997 5.25 21.9997H2.25C1.00736 21.9997 0 20.9923 0 19.7497V8.46931C0 7.78693 0.309674 7.14142 0.841907 6.71438L8.59191 0.496049ZM10.4694 1.666C10.1951 1.44597 9.80486 1.44597 9.53063 1.666L1.78064 7.88433C1.60322 8.02668 1.5 8.24185 1.5 8.46931V19.7497C1.5 20.1639 1.83579 20.4997 2.25 20.4997H5.25C5.66421 20.4997 6 20.1639 6 19.7497V13.7497C6 12.5071 7.00736 11.4997 8.25 11.4997H11.75C12.9926 11.4997 14 12.5071 14 13.7497V19.7497C14 20.1639 14.3358 20.4997 14.75 20.4997H17.75C18.1642 20.4997 18.5 20.1639 18.5 19.7497V8.46931C18.5 8.24185 18.3968 8.02668 18.2194 7.88433L10.4694 1.666Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <!-- Sección derecha: Navegación + Separador + Acciones -->
    <div class="header-right">
      <!-- Navegación principal -->
      <nav class="header-nav">

        <!--button
          mat-button
          class="nav-item"
          [class.active]="isNavItemActive('beneficios')"
          (click)="navigateTo('/beneficios')"
          aria-label="Beneficios">
          <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 11C8.82843 11 9.5 11.6716 9.5 12.5V16.5C9.5 17.3284 8.82843 18 8 18H4C3.17157 18 2.5 17.3284 2.5 16.5V12.5C2.5 11.6716 3.17157 11 4 11H8ZM17 11C17.8284 11 18.5 11.6716 18.5 12.5V16.5C18.5 17.3284 17.8284 18 17 18H13C12.1716 18 11.5 17.3284 11.5 16.5V12.5C11.5 11.6716 12.1716 11 13 11H17ZM8 12H4C3.72386 12 3.5 12.2239 3.5 12.5V16.5C3.5 16.7761 3.72386 17 4 17H8C8.27614 17 8.5 16.7761 8.5 16.5V12.5C8.5 12.2239 8.27614 12 8 12ZM17 12H13C12.7239 12 12.5 12.2239 12.5 12.5V16.5C12.5 16.7761 12.7239 17 13 17H17C17.2761 17 17.5 16.7761 17.5 16.5V12.5C17.5 12.2239 17.2761 12 17 12ZM8 2C8.82843 2 9.5 2.67157 9.5 3.5V7.5C9.5 8.32843 8.82843 9 8 9H4C3.17157 9 2.5 8.32843 2.5 7.5V3.5C2.5 2.67157 3.17157 2 4 2H8ZM17 2C17.8284 2 18.5 2.67157 18.5 3.5V7.5C18.5 8.32843 17.8284 9 17 9H13C12.1716 9 11.5 8.32843 11.5 7.5V3.5C11.5 2.67157 12.1716 2 13 2H17ZM8 3H4C3.72386 3 3.5 3.22386 3.5 3.5V7.5C3.5 7.77614 3.72386 8 4 8H8C8.27614 8 8.5 7.77614 8.5 7.5V3.5C8.5 3.22386 8.27614 3 8 3ZM17 3H13C12.7239 3 12.5 3.22386 12.5 3.5V7.5C12.5 7.77614 12.7239 8 13 8H17C17.2761 8 17.5 7.77614 17.5 7.5V3.5C17.5 3.22386 17.2761 3 17 3Z" fill="currentColor"/>
          </svg>
          <span class="nav-text">Beneficios</span>
        </button-->


        <button
          mat-button
          class="nav-item"
          [class.active]="isNavItemActive('servicios')"
          (click)="navigateTo('/services')"
          aria-label="Servicios">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 14.5C8.94957 14.5 8.08828 13.6902 8.00637 12.6608C5.67266 11.839 4 9.61482 4 7C4 3.68629 6.68629 1 10 1C13.1454 1 15.7255 3.42031 15.9795 6.50015C16.0022 6.77536 15.7761 7 15.5 7C15.2239 7 15.0026 6.7755 14.9754 6.5007C14.7248 3.9737 12.5929 2 10 2C7.23858 2 5 4.23858 5 7C5 9.12095 6.32058 10.9335 8.18436 11.6601C8.50175 10.9751 9.19539 10.5 10 10.5C11.1046 10.5 12 11.3954 12 12.5C12 13.6046 11.1046 14.5 10 14.5ZM5.00873 12H5.10126C5.49036 12.3812 5.92373 12.7174 6.39291 13L5.00873 13C4.44786 13 4 13.4467 4 14C4 15.3088 4.62226 16.2837 5.67262 16.9534C6.74318 17.636 8.26489 18 10 18C11.7351 18 13.2568 17.636 14.3274 16.9534C15.3777 16.2837 16 15.3088 16 14C16 13.4478 15.5522 13 15 13L12.9585 13C12.9858 12.8374 13 12.6704 13 12.5C13 12.3296 12.9858 12.1626 12.9585 12L15 12C16.1045 12 17 12.8956 17 14C17 15.6912 16.1672 16.9663 14.865 17.7966C13.583 18.614 11.8547 19 10 19C8.14526 19 6.41697 18.614 5.13499 17.7966C3.83281 16.9663 3 15.6912 3 14C3 12.8869 3.90315 12 5.00873 12ZM14 7C14 8.42652 13.2533 9.67862 12.1294 10.3867C11.8646 10.12 11.5501 9.90271 11.2009 9.75C12.2599 9.28687 13 8.22986 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.22989 7.74009 9.28692 8.79922 9.75003C8.44987 9.90284 8.13539 10.1202 7.87079 10.3868C7.11872 9.91303 6.53552 9.19566 6.23191 8.34544C6.11009 8.00425 6.0333 7.64176 6.00865 7.26515C6.00291 7.1775 6 7.08909 6 7C6 4.79086 7.79086 3 10 3C12.2091 3 14 4.79086 14 7Z" fill="currentColor"/>
          </svg>
          <span class="nav-text">Servicios</span>
        </button>

        <button
          mat-button
          class="nav-item"
          [class.active]="isNavItemActive('solicitudes')"
          (click)="navigateTo('/solicitudes')"
          aria-label="Solicitudes">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 3.5C2 2.67157 2.67157 2 3.5 2H4.5C5.32843 2 6 2.67157 6 3.5V4.5C6 5.32843 5.32843 6 4.5 6H3.5C2.67157 6 2 5.32843 2 4.5V3.5ZM3.5 3C3.22386 3 3 3.22386 3 3.5V4.5C3 4.77614 3.22386 5 3.5 5H4.5C4.77614 5 5 4.77614 5 4.5V3.5C5 3.22386 4.77614 3 4.5 3H3.5ZM2 9.5C2 8.67157 2.67157 8 3.5 8H4.5C5.32843 8 6 8.67157 6 9.5V10.5C6 11.3284 5.32843 12 4.5 12H3.5C2.67157 12 2 11.3284 2 10.5V9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5V10.5C3 10.7761 3.22386 11 3.5 11H4.5C4.77614 11 5 10.7761 5 10.5V9.5C5 9.22386 4.77614 9 4.5 9H3.5ZM2 15.5C2 14.6716 2.67157 14 3.5 14H4.5C5.32843 14 6 14.6716 6 15.5V16.5C6 17.3284 5.32843 18 4.5 18H3.5C2.67157 18 2 17.3284 2 16.5V15.5ZM3.5 15C3.22386 15 3 15.2239 3 15.5V16.5C3 16.7761 3.22386 17 3.5 17H4.5C4.77614 17 5 16.7761 5 16.5V15.5C5 15.2239 4.77614 15 4.5 15H3.5ZM8 4.5C8 4.22386 8.22386 4 8.5 4H17.5C17.7761 4 18 4.22386 18 4.5C18 4.77614 17.7761 5 17.5 5H8.5C8.22386 5 8 4.77614 8 4.5ZM8 10.5C8 10.2239 8.22386 10 8.5 10H17.5C17.7761 10 18 10.2239 18 10.5C18 10.7761 17.7761 11 17.5 11H8.5C8.22386 11 8 10.7761 8 10.5ZM8 16.5C8 16.2239 8.22386 16 8.5 16H17.5C17.7761 16 18 16.2239 18 16.5C18 16.7761 17.7761 17 17.5 17H8.5C8.22386 17 8 16.7761 8 16.5Z" fill="currentColor"/>
          </svg>
          <span class="nav-text">Solicitudes</span>
        </button>
      </nav>

      <!-- Separador vertical -->
      <div class="divider"></div>

      <!-- Acciones rápidas -->
      <div class="header-actions">
        <!-- Botón toggle para colapsar/expandir datos de usuario -->
        <button
          mat-icon-button
          class="action-btn toggle-btn"
          (click)="toggleUserData()"
          [attr.aria-label]="isUserDataCollapsed ? 'Expandir datos' : 'Colapsar datos'"
          title="{{ isUserDataCollapsed ? 'Expandir datos' : 'Colapsar datos' }}">
          <mat-icon>{{ isUserDataCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
        </button>

        <button  hidden
          mat-icon-button
          class="action-btn notification-btn"
          (click)="onNotificationClick()"
          aria-label="Notificaciones"
          [matBadge]="notificationCount > 0 ? notificationCount : null"
          matBadgeColor="warn"
          matBadgeSize="small">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.9897 0.66333C9.19593 0.66333 10.3231 1.0024 11.2794 1.59207C10.9945 1.89646 10.7742 2.26184 10.6402 2.66646C9.87138 2.18839 8.96283 1.91299 7.9897 1.91299C5.21914 1.91299 2.98331 4.14093 2.98291 6.91164V10.5853L1.86141 13.1631H14.1251L12.9965 10.5861L12.9966 6.92235L12.9935 6.73473C12.9904 6.64445 12.9849 6.55481 12.9771 6.46585C13.1196 6.48718 13.2654 6.49824 13.4138 6.49824C13.6956 6.49824 13.968 6.4584 14.2258 6.38408C14.2347 6.48948 14.241 6.59567 14.2447 6.70257L14.2482 6.91164V10.3249L15.3998 12.9542C15.4574 13.0857 15.4871 13.2278 15.4871 13.3714C15.4871 13.9465 15.0201 14.4128 14.444 14.4128L10.4931 14.414C10.4931 15.7943 9.37229 16.9133 7.9897 16.9133C6.65649 16.9133 5.5667 15.8728 5.49056 14.5609L5.48593 14.4121L1.54335 14.4128C1.40037 14.4128 1.25892 14.3834 1.12778 14.3265C0.599396 14.0974 0.35711 13.484 0.586621 12.9565L1.73121 10.3257V6.91155C1.73171 3.45016 4.52841 0.66333 7.9897 0.66333ZM9.24102 14.4121L6.73801 14.414C6.73801 15.1042 7.29841 15.6637 7.9897 15.6637C8.64033 15.6637 9.17502 15.1681 9.23567 14.5344L9.24102 14.4121ZM11.3608 3.21046C11.4401 2.77119 11.6574 2.37978 11.9663 2.08258C12.3414 1.7216 12.8517 1.49959 13.4138 1.49959C14.566 1.49959 15.5 2.43208 15.5 3.58236C15.5 4.4931 14.9145 5.26731 14.0988 5.55027C13.8842 5.62469 13.6538 5.66513 13.4138 5.66513C13.2068 5.66513 13.0069 5.63503 12.8181 5.57898C11.9562 5.32305 11.3277 4.52599 11.3277 3.58236C11.3277 3.45542 11.3391 3.33114 11.3608 3.21046Z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Sección de información del usuario - Espacio adicional de 180px -->
  <div class="user-profile-section"
       [class.collapsed]="isUserDataCollapsed"
       *ngIf="!isPasswordChangeSection && !isUserDataCollapsed">
    <div class="user-profile-container">
      <div class="user-avatar-large">
        <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 14C18.6569 14 20 15.3431 20 17V17.7146C20 21.2924 15.7895 24 10 24C4.21053 24 0 21.4333 0 17.7146V17C0 15.3431 1.34315 14 3 14H17ZM10 0C13.3137 0 16 2.68629 16 6C16 9.31371 13.3137 12 10 12C6.68629 12 4 9.31371 4 6C4 2.68629 6.68629 0 10 0Z" fill="#0E365A"/>
        </svg>
      </div>
      <div class="user-details">
        <h3 class="user-name">{{ getUserDisplayName() }}</h3>

        <div class="user-detail" *ngIf="!isAccountBanamex()">
          <span class="detail-title">Inicio vigencia:</span>
          <span class="detail-text">{{ formatDate(getUserStartDate()) }}</span>
        </div>
        <div class="user-detail" *ngIf="!isAccountBanamex()">
          <span class="detail-title">Fin vigencia:</span>
          <span class="detail-text">{{ formatDate(getUserEndDate()) }}</span>
        </div>
        <a
          *ngIf="shouldShowManageProfile()"
          (click)="navigateToManageProfile()"
          class="admin-link">
          Administrar perfil
        </a>
        <a (click)="logout()" class="admin-link">
          Cerrar sesión</a>
      </div>
    </div>
  </div>

  <!-- Título para cambio de contraseña - igual que custom-title-section en header-home -->
  <div class="password-change-title-section" *ngIf="isPasswordChangeSection">
    <div class="password-change-title-container">
      <h1 class="password-change-title">Cambiar contraseña</h1>
    </div>
  </div>

  <!-- Línea amarilla inferior -->
  <div class="bottom-line"></div>
</header>

<!-- Header para móvil -->
<header class="header-profile mobile-header"
        [class.password-change-height]="isPasswordChangeSection"
        [class.user-collapsed]="isUserDataCollapsed">
  <div class="mobile-container">
    <!-- Botón Home móvil -->
    <div class="mobile-home-section">
      <button
        mat-icon-button
        class="action-btn home-btn"
        (click)="navigateTo('/home')"
        aria-label="Inicio">
        <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.59191 0.496049C9.41459 -0.164047 10.5854 -0.164048 11.4081 0.496048L19.1581 6.71438C19.6903 7.14142 20 7.78693 20 8.46931V19.7497C20 20.9923 18.9926 21.9997 17.75 21.9997H14.75C13.5074 21.9997 12.5 20.9923 12.5 19.7497V13.7497C12.5 13.3355 12.1642 12.9997 11.75 12.9997H8.25C7.83579 12.9997 7.5 13.3355 7.5 13.7497V19.7497C7.5 20.9923 6.49264 21.9997 5.25 21.9997H2.25C1.00736 21.9997 0 20.9923 0 19.7497V8.46931C0 7.78693 0.309674 7.14142 0.841907 6.71438L8.59191 0.496049ZM10.4694 1.666C10.1951 1.44597 9.80486 1.44597 9.53063 1.666L1.78064 7.88433C1.60322 8.02668 1.5 8.24185 1.5 8.46931V19.7497C1.5 20.1639 1.83579 20.4997 2.25 20.4997H5.25C5.66421 20.4997 6 20.1639 6 19.7497V13.7497C6 12.5071 7.00736 11.4997 8.25 11.4997H11.75C12.9926 11.4997 14 12.5071 14 13.7497V19.7497C14 20.1639 14.3358 20.4997 14.75 20.4997H17.75C18.1642 20.4997 18.5 20.1639 18.5 19.7497V8.46931C18.5 8.24185 18.3968 8.02668 18.2194 7.88433L10.4694 1.666Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <!-- Sección de acciones de la derecha: toggle + hamburguesa -->
    <div class="mobile-actions-right">
      <!-- Botón toggle para colapsar/expandir datos de usuario -->
      <button
        mat-icon-button
        class="action-btn toggle-btn"
        (click)="toggleUserData()"
        [attr.aria-label]="isUserDataCollapsed ? 'Expandir datos' : 'Colapsar datos'"
        title="{{ isUserDataCollapsed ? 'Expandir datos' : 'Colapsar datos' }}">
        <mat-icon>{{ isUserDataCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>

      <!-- Botón de menú hamburguesa -->
      <button
        mat-icon-button
        class="hamburger-btn"
        (click)="onMenuClick()"
        [class.menu-open]="isMobileMenuOpen"
        aria-label="Menú">
        <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
  </div>

  <!-- Sección de información del usuario móvil - Espacio adicional de 180px -->
  <div class="user-profile-section"
       [class.collapsed]="isUserDataCollapsed"
       *ngIf="!isPasswordChangeSection && !isUserDataCollapsed">
    <div class="user-profile-container">
      <div class="user-avatar-large">
        <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 14C18.6569 14 20 15.3431 20 17V17.7146C20 21.2924 15.7895 24 10 24C4.21053 24 0 21.4333 0 17.7146V17C0 15.3431 1.34315 14 3 14H17ZM10 0C13.3137 0 16 2.68629 16 6C16 9.31371 13.3137 12 10 12C6.68629 12 4 9.31371 4 6C4 2.68629 6.68629 0 10 0Z" fill="#0E365A"/>
        </svg>
      </div>
      <div class="user-details">
        <h3 class="user-name">{{ getUserDisplayName() }}</h3>

        <div class="user-detail" *ngIf="!isAccountBanamex()">
          <span class="detail-title">Inicio vigencia:</span>
          <span class="detail-text">{{ formatDate(getUserStartDate()) }}</span>
        </div>
        <div class="user-detail" *ngIf="!isAccountBanamex()">
          <span class="detail-title">Fin vigencia:</span>
          <span class="detail-text">{{ formatDate(getUserEndDate()) }}</span>
        </div>
        <a
          *ngIf="shouldShowManageProfile()"
          (click)="navigateToManageProfile()"
          class="admin-link">
          Administrar perfil
        </a>
      </div>
    </div>
  </div>

  <!-- Título para cambio de contraseña en móvil - igual que custom-title-section en header-home -->
  <div class="password-change-title-section" *ngIf="isPasswordChangeSection">
    <div class="password-change-title-container">
      <h1 class="password-change-title">Cambiar contraseña</h1>
    </div>
  </div>

  <!-- Menú desplegable móvil -->
  <div class="mobile-menu" [class.open]="isMobileMenuOpen">
    <div class="mobile-menu-overlay" (click)="closeMobileMenu()"></div>
    <nav class="mobile-menu-content">
      <div class="mobile-menu-header">
        <!-- Sección izquierda: Avatar y saludo (como era originalmente) -->
        <div class="header-left">
          <div class="user-info">
            <div class="user-avatar">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 14C18.6569 14 20 15.3431 20 17V17.7146C20 21.2924 15.7895 24 10 24C4.21053 24 0 21.4333 0 17.7146V17C0 15.3431 1.34315 14 3 14H17ZM10 0C13.3137 0 16 2.68629 16 6C16 9.31371 13.3137 12 10 12C6.68629 12 4 9.31371 4 6C4 2.68629 6.68629 0 10 0Z" fill="#0E365A"/>
              </svg>
            </div>
            <span class="greeting headline-04 truncate-name-menu">Hola, {{ getUserDisplayName() }}</span>
          </div>
        </div>

        <!-- Botón de notificaciones (igual que desktop) -->
        <button  hidden
          mat-icon-button
          class="action-btn notification-btn"
          (click)="onNotificationClick()"
          aria-label="Notificaciones"
          [matBadge]="notificationCount > 0 ? notificationCount : null"
          matBadgeColor="warn"
          matBadgeSize="small">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.9897 0.66333C9.19593 0.66333 10.3231 1.0024 11.2794 1.59207C10.9945 1.89646 10.7742 2.26184 10.6402 2.66646C9.87138 2.18839 8.96283 1.91299 7.9897 1.91299C5.21914 1.91299 2.98331 4.14093 2.98291 6.91164V10.5853L1.86141 13.1631H14.1251L12.9965 10.5861L12.9966 6.92235L12.9935 6.73473C12.9904 6.64445 12.9849 6.55481 12.9771 6.46585C13.1196 6.48718 13.2654 6.49824 13.4138 6.49824C13.6956 6.49824 13.968 6.4584 14.2258 6.38408C14.2347 6.48948 14.241 6.59567 14.2447 6.70257L14.2482 6.91164V10.3249L15.3998 12.9542C15.4574 13.0857 15.4871 13.2278 15.4871 13.3714C15.4871 13.9465 15.0201 14.4128 14.444 14.4128L10.4931 14.414C10.4931 15.7943 9.37229 16.9133 7.9897 16.9133C6.65649 16.9133 5.5667 15.8728 5.49056 14.5609L5.48593 14.4121L1.54335 14.4128C1.40037 14.4128 1.25892 14.3834 1.12778 14.3265C0.599396 14.0974 0.35711 13.484 0.586621 12.9565L1.73121 10.3257V6.91155C1.73171 3.45016 4.52841 0.66333 7.9897 0.66333ZM9.24102 14.4121L6.73801 14.414C6.73801 15.1042 7.29841 15.6637 7.9897 15.6637C8.64033 15.6637 9.17502 15.1681 9.23567 14.5344L9.24102 14.4121ZM11.3608 3.21046C11.4401 2.77119 11.6574 2.37978 11.9663 2.08258C12.3414 1.7216 12.8517 1.49959 13.4138 1.49959C14.566 1.49959 15.5 2.43208 15.5 3.58236C15.5 4.4931 14.9145 5.26731 14.0988 5.55027C13.8842 5.62469 13.6538 5.66513 13.4138 5.66513C13.2068 5.66513 13.0069 5.63503 12.8181 5.57898C11.9562 5.32305 11.3277 4.52599 11.3277 3.58236C11.3277 3.45542 11.3391 3.33114 11.3608 3.21046Z" fill="currentColor"/>
          </svg>
        </button>
      </div>

      <div class="mobile-menu-items">

        <!--button
          class="mobile-nav-item"
          [class.active]="isNavItemActive('beneficios')"
          (click)="navigateFromMobile('/beneficios')"
          aria-label="Beneficios">
          <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 11C8.82843 11 9.5 11.6716 9.5 12.5V16.5C9.5 17.3284 8.82843 18 8 18H4C3.17157 18 2.5 17.3284 2.5 16.5V12.5C2.5 11.6716 3.17157 11 4 11H8ZM17 11C17.8284 11 18.5 11.6716 18.5 12.5V16.5C18.5 17.3284 17.8284 18 17 18H13C12.1716 18 11.5 17.3284 11.5 16.5V12.5C11.5 11.6716 12.1716 11 13 11H17ZM8 12H4C3.72386 12 3.5 12.2239 3.5 12.5V16.5C3.5 16.7761 3.72386 17 4 17H8C8.27614 17 8.5 16.7761 8.5 16.5V12.5C8.5 12.2239 8.27614 12 8 12ZM17 12H13C12.7239 12 12.5 12.2239 12.5 12.5V16.5C12.5 16.7761 12.7239 17 13 17H17C17.2761 17 17.5 16.7761 17.5 16.5V12.5C17.5 12.2239 17.2761 12 17 12ZM8 2C8.82843 2 9.5 2.67157 9.5 3.5V7.5C9.5 8.32843 8.82843 9 8 9H4C3.17157 9 2.5 8.32843 2.5 7.5V3.5C2.5 2.67157 3.17157 2 4 2H8ZM17 2C17.8284 2 18.5 2.67157 18.5 3.5V7.5C18.5 8.32843 17.8284 9 17 9H13C12.1716 9 11.5 8.32843 11.5 7.5V3.5C11.5 2.67157 12.1716 2 13 2H17ZM8 3H4C3.72386 3 3.5 3.22386 3.5 3.5V7.5C3.5 7.77614 3.72386 8 4 8H8C8.27614 8 8.5 7.77614 8.5 7.5V3.5C8.5 3.22386 8.27614 3 8 3ZM17 3H13C12.7239 3 12.5 3.22386 12.5 3.5V7.5C12.5 7.77614 12.7239 8 13 8H17C17.2761 8 17.5 7.77614 17.5 7.5V3.5C17.5 3.22386 17.2761 3 17 3Z" fill="currentColor"/>
          </svg>
          <span class="mobile-nav-text">Beneficios</span>
        </button-->


        <button
          class="mobile-nav-item"
          [class.active]="isNavItemActive('servicios')"
          (click)="navigateFromMobile('/services')"
          aria-label="Servicios">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 14.5C8.94957 14.5 8.08828 13.6902 8.00637 12.6608C5.67266 11.839 4 9.61482 4 7C4 3.68629 6.68629 1 10 1C13.1454 1 15.7255 3.42031 15.9795 6.50015C16.0022 6.77536 15.7761 7 15.5 7C15.2239 7 15.0026 6.7755 14.9754 6.5007C14.7248 3.9737 12.5929 2 10 2C7.23858 2 5 4.23858 5 7C5 9.12095 6.32058 10.9335 8.18436 11.6601C8.50175 10.9751 9.19539 10.5 10 10.5C11.1046 10.5 12 11.3954 12 12.5C12 13.6046 11.1046 14.5 10 14.5ZM5.00873 12H5.10126C5.49036 12.3812 5.92373 12.7174 6.39291 13L5.00873 13C4.44786 13 4 13.4467 4 14C4 15.3088 4.62226 16.2837 5.67262 16.9534C6.74318 17.636 8.26489 18 10 18C11.7351 18 13.2568 17.636 14.3274 16.9534C15.3777 16.2837 16 15.3088 16 14C16 13.4478 15.5522 13 15 13L12.9585 13C12.9858 12.8374 13 12.6704 13 12.5C13 12.3296 12.9858 12.1626 12.9585 12L15 12C16.1045 12 17 12.8956 17 14C17 15.6912 16.1672 16.9663 14.865 17.7966C13.583 18.614 11.8547 19 10 19C8.14526 19 6.41697 18.614 5.13499 17.7966C3.83281 16.9663 3 15.6912 3 14C3 12.8869 3.90315 12 5.00873 12ZM14 7C14 8.42652 13.2533 9.67862 12.1294 10.3867C11.8646 10.12 11.5501 9.90271 11.2009 9.75C12.2599 9.28687 13 8.22986 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.22989 7.74009 9.28692 8.79922 9.75003C8.44987 9.90284 8.13539 10.1202 7.87079 10.3868C7.11872 9.91303 6.53552 9.19566 6.23191 8.34544C6.11009 8.00425 6.0333 7.64176 6.00865 7.26515C6.00291 7.1775 6 7.08909 6 7C6 4.79086 7.79086 3 10 3C12.2091 3 14 4.79086 14 7Z" fill="currentColor"/>
          </svg>
          <span class="mobile-nav-text">Servicios</span>
        </button>

        <button
          class="mobile-nav-item"
          [class.active]="isNavItemActive('solicitudes')"
          (click)="navigateFromMobile('/solicitudes')"
          aria-label="Solicitudes">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 3.5C2 2.67157 2.67157 2 3.5 2H4.5C5.32843 2 6 2.67157 6 3.5V4.5C6 5.32843 5.32843 6 4.5 6H3.5C2.67157 6 2 5.32843 2 4.5V3.5ZM3.5 3C3.22386 3 3 3.22386 3 3.5V4.5C3 4.77614 3.22386 5 3.5 5H4.5C4.77614 5 5 4.77614 5 4.5V3.5C5 3.22386 4.77614 3 4.5 3H3.5ZM2 9.5C2 8.67157 2.67157 8 3.5 8H4.5C5.32843 8 6 8.67157 6 9.5V10.5C6 11.3284 5.32843 12 4.5 12H3.5C2.67157 12 2 11.3284 2 10.5V9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5V10.5C3 10.7761 3.22386 11 3.5 11H4.5C4.77614 11 5 10.7761 5 10.5V9.5C5 9.22386 4.77614 9 4.5 9H3.5ZM2 15.5C2 14.6716 2.67157 14 3.5 14H4.5C5.32843 14 6 14.6716 6 15.5V16.5C6 17.3284 5.32843 18 4.5 18H3.5C2.67157 18 2 17.3284 2 16.5V15.5ZM3.5 15C3.22386 15 3 15.2239 3 15.5V16.5C3 16.7761 3.22386 17 3.5 17H4.5C4.77614 17 5 16.7761 5 16.5V15.5C5 15.2239 4.77614 15 4.5 15H3.5ZM8 4.5C8 4.22386 8.22386 4 8.5 4H17.5C17.7761 4 18 4.22386 18 4.5C18 4.77614 17.7761 5 17.5 5H8.5C8.22386 5 8 4.77614 8 4.5ZM8 10.5C8 10.2239 8.22386 10 8.5 10H17.5C17.7761 10 18 10.2239 18 10.5C18 10.7761 17.7761 11 17.5 11H8.5C8.22386 11 8 10.7761 8 10.5ZM8 16.5C8 16.2239 8.22386 16 8.5 16H17.5C17.7761 16 18 16.2239 18 16.5C18 16.7761 17.7761 17 17.5 17H8.5C8.22386 17 8 16.7761 8 16.5Z" fill="currentColor"/>
          </svg>
          <span class="mobile-nav-text">Solicitudes</span>
        </button>

        <button
          class="mobile-nav-item btn-logout"
          (click)="logout()" aria-label="Cerrar sesión">
          <mat-icon>logout</mat-icon>
          <span class="mobile-nav-text">Cerrar sesión</span>
        </button>
      </div>
    </nav>
  </div>

  <!-- Título para cambio de contraseña en móvil - igual que custom-title-section en header-home -->
  <div class="password-change-title-section" *ngIf="isPasswordChangeSection">
    <div class="password-change-title-container">
      <h1 class="password-change-title">Cambiar contraseña</h1>
    </div>
  </div>

  <!-- Línea amarilla inferior -->
  <div class="bottom-line"></div>
</header>
